import * as React from 'react'
import { navigate } from 'gatsby'
import Layout from 'containers/Layout'
import Container from 'theme/atoms/Container'
import Story from 'theme/atoms/Story'
import Seo from 'theme/atoms/SEO'
import config from 'config'
import * as t from './types'
import useAccount from 'hooks/account/useAccount'

const isBrowser = typeof window !== 'undefined'

export default function Home(props: t.Props) {
  const { channel, channelLoaded } = useAccount()

  React.useEffect(() => {
    if (!channelLoaded) return
    if (!config.features.b2cHomePage) return
    if (
      channel === 'b2c' &&
      isBrowser &&
      !window?.location.pathname.includes('/b2c/')
    ) {
      // Navigate to b2c homepage, but replace the browser history entry.
      // This way if the user navigates back, they will go to the previous page.
      // Therefore it should not trigger a redirect loop.
      // This should fix WDV-3600
      navigate('/b2c/' + location.search, { replace: true })
    }

    if (
      channel === 'b2b' &&
      isBrowser &&
      window?.location.pathname.includes('/b2c/')
    ) {
      navigate('/' + location.search)
    }
  }, [channel, channelLoaded])

  if (!props.data.staticBlock) {
    navigate('/404/')
    return null
  }

  return (
    <Layout pageContext={{ type: 'Homepage', ready: true }}>
      <Seo
        canonicalUrl={`${config.baseUrl}${props.location.pathname}`}
        location={props.location}
        title={props.data.staticBlock.title}
        description={props.data.staticBlock.description}
        type="website"
        seoNoIndex={props.data.staticBlock.seoNoIndex}
        seoNoFollow={props.data.staticBlock.seoNoFollow}
        hrefLang={props.pageContext.hrefLang}
      />
      <Container>
        <div style={{ height: 40 }} />
        <Story
          story={props.data.staticBlock?.story}
          cfId={props.data.staticBlock?.contentfulID}
        />
      </Container>
    </Layout>
  )
}
